





import { Component, Vue } from 'vue-property-decorator';

@Component
export default class PublicLayout extends Vue {
}
